// extracted by mini-css-extract-plugin
export default {"base":"Back_base__CO5qd","isDisabled":"Back_isDisabled__iW2BA","content":"Back_content__oP5hc","glitch":"Back_glitch__4apPi","blink-button":"Back_blink-button__2A7nj"};